import routes from 'routes';
import {
  Operators,
  OnlineConversationPanel,
  BlackList,
  UpgradeIcon,
  ProgramsIcon,
  WelcomeIconComponent,
  GeneralSettingsIconComponent,
  UpgradeMiniIconComponent,
  DevelopersIconComponent,
  ChargeConvIcon,
  CheckoutListIconComponent,
  WebHookIconComponent,
  ApisIconComponent,
  WidgetSettingsIconComponent,
  StatsIconComponent,
  Affiliate,
} from 'assets/icons';
import { RAYCHAT_APP_V2_URL, REACT_APP_APPS_LIST_LINK } from 'utils/constants';
import {
  setSecondMenuCollapsed,
  setSecondMenuKey,
} from 'redux/layout/layout.actions';

// const getSecondMenuItemsForWidgetSettings = (channelId) => {
//   const WIDGETـSETTINGS_ITEMS = [
//     {
//       text_fa: 'نصب',
//       text_en: 'Installation',
//       link_to: routes.widgetInstallation,
//       isExternalLink: false,
//     },
//     // {
//     //   text_fa: 'تخصیص اپراتور',
//     //   text_en: 'Operator Assignment',
//     //   link_to: routes.appsList,
//     //   isExternalLink: false,
//     // },
//     {
//       text_fa: 'آرشیو مکالمات',
//       text_en: 'Conversations Archive',
//       link_to: `/conversations-archive/all`,
//       isExternalLink: false,
//     },
//     {
//       text_fa: 'پایگاه دانش',
//       text_en: 'Knowledge Base',
//       link_to: undefined,
//       isExternalLink: false,
//       subItems: [
//         {
//           text_fa: 'لیست پرسش ها',
//           text_en: 'FAQ List',
//           link_to: routes.faqList,
//           isExternalLink: false,
//           closeSecondMenuOnClick: true,
//         },
//         {
//           text_fa: 'ایجاد پرسش جدید',
//           text_en: 'Add New FAQ',
//           link_to: routes.addFaq,
//           isExternalLink: false,
//           closeSecondMenuOnClick: true,
//         },
//         {
//           text_fa: 'شخصی سازی پایگاه دانش',
//           text_en: 'FAQ Customization',
//           link_to: routes.knowledgeBasePage,
//           isExternalLink: false,
//           closeSecondMenuOnClick: true,
//         },
//       ],
//     },
//     {
//       text_fa: 'دپارتمان',
//       text_en: 'Department',
//       link_to: routes.teams,
//       isExternalLink: false,
//     },
//     {
//       text_fa: 'پیام گروهی',
//       text_en: 'Group Messaging',
//       link_to: routes.groupMessage,
//       isExternalLink: false,
//     },
//     {
//       text_fa: 'واتس آپ',
//       text_en: 'Whatsapp',
//       link_to: routes.connectWhatsapp,
//       isExternalLink: false,
//     },
//     {
//       text_fa: 'تنظیمات عمومی',
//       text_en: 'General Settings',
//       link_to: `/settings/widget#general-settings`,
//       isExternalLink: false,
//     },
//     {
//       text_fa: 'شخصی سازی',
//       text_en: 'Customize',
//       link_to: `/settings/widget#landing`,
//       isExternalLink: false,
//     },
//     {
//       text_fa: 'زمان های کاری',
//       text_en: 'Working Hours',
//       link_to: `/settings/office-hours`,
//       isExternalLink: false,
//     },
//     {
//       text_fa: 'ایمیل یاد آوری',
//       text_en: 'Email Reminder',
//       link_to: `/settings/email`,
//       isExternalLink: false,
//     },
//     {
//       text_fa: 'هوشمند سازی',
//       text_en: 'Make Smart', // I couldn't find a better name for it XD
//       link_to: `/settings/auto-message`,
//       isExternalLink: false,
//     },
//     {
//       text_fa: 'حالت انتظار',
//       text_en: 'Waiting Mode',
//       link_to: `/settings/response-delay`,
//       isExternalLink: false,
//     },
//     {
//       text_fa: 'فرم ساز',
//       text_en: 'Form Generator',
//       link_to: `/settings/form-generator`,
//       isExternalLink: false,
//     },
//     {
//       text_fa: 'ربات پاسخگو',
//       text_en: 'Responsive Robot',
//       link_to: `/settings/responsive-robot`,
//       isExternalLink: false,
//     },
//   ];

//   return WIDGETـSETTINGS_ITEMS;
// };

const handleClickOnWidgetSettings = ({ dispatch, k }) => {
  // dispatch(setSideMenuCollapse(true));
  dispatch(setSecondMenuKey(k));
  dispatch(setSecondMenuCollapsed(false));
};

export const MENU_ITEMS = [
  {
    text_en: 'General Settings',
    text_fa: 'تنظیمات عمومی',
    icon: GeneralSettingsIconComponent,
    expandable: true,
    accessLevels: ['admin'],
    subItems: [
      {
        text_fa: 'داشبورد',
        text_en: 'Dashboard',
        icon: WelcomeIconComponent,
        url: routes.websites,
        closeSecondMenuOnClick: true,
        // accessLevels: ['admin'],
      },
      {
        text_fa: 'تنظیمات ابزارک',
        text_en: 'Widget Settings',
        key: 'Widget-Settings',
        icon: WidgetSettingsIconComponent,
        url: undefined,
        hasMoreItemsArrow: true,
        closeSecondMenuOnClick: false,
        on_click_handler: handleClickOnWidgetSettings,
        // accessLevels: ['admin'],
      },
      {
        text_fa: 'آمار',
        text_en: 'Statistics',
        key: 'Stats',
        icon: StatsIconComponent,
        url: undefined,
        hasMoreItemsArrow: true,
        closeSecondMenuOnClick: false,
        on_click_handler: handleClickOnWidgetSettings,
        // accessLevels: ['admin'],
      },
      {
        text_fa: 'اپراتورها',
        text_en: 'Operators',
        icon: Operators,
        url: routes.operators,
        closeSecondMenuOnClick: true,
        // accessLevels: ['admin'],
      },
      {
        text_fa: 'پنل گفتگو',
        text_en: 'Web app',
        icon: OnlineConversationPanel,
        url: RAYCHAT_APP_V2_URL,
        isExternalLink: true,
        // accessLevels: ['admin', 'user'],
        subItem: [],
      },
      {
        text_fa: 'لیست سیاه',
        text_en: 'Black list',
        icon: BlackList,
        url: routes.blacklist,
        closeSecondMenuOnClick: true,
        // accessLevels: ['admin'],
      },
      {
        text_fa: 'همکاری در فروش',
        text_en: 'Affiliation',
        icon: Affiliate,
        url: routes.affiliatePage,
        closeSecondMenuOnClick: true,
        // accessLevels: ['admin'],
      },
    ],
  },
  {
    text_en: 'Upgrade',
    text_fa: 'تمدید و ارتقا',
    icon: UpgradeMiniIconComponent,
    expandable: true,
    accessLevels: ['admin'],
    subItems: [
      {
        text_fa: 'تمدید و ارتقا',
        text_en: 'Upgrade Package',
        url: routes.packageUpgrade,
        icon: UpgradeIcon,
        closeSecondMenuOnClick: true,
      },
      {
        text_fa: 'شارژ مکالمه',
        text_en: 'Conversation Charge',
        url: routes.conversationsChagrge,
        icon: ChargeConvIcon,
        closeSecondMenuOnClick: true,
      },
      {
        text_fa: 'لیست صورتحساب',
        text_en: 'Bills',
        url: routes.bills,
        icon: CheckoutListIconComponent,
        closeSecondMenuOnClick: true,
      },
    ],
  },
  {
    text_en: 'Developers',
    text_fa: 'توسعه دهندگان',
    icon: DevelopersIconComponent,
    expandable: true,
    accessLevels: ['admin'],
    subItems: [
      {
        text_fa: 'لیست برنامه ها',
        text_en: 'Apps List',
        icon: ProgramsIcon,
        url: routes.appsList,
        closeSecondMenuOnClick: true,
      },
      {
        text_fa: 'وب هوک',
        text_en: 'Web hook',
        icon: WebHookIconComponent,
        url: routes.webhookList,
        closeSecondMenuOnClick: true,
      },
      {
        text_fa: 'APIs',
        text_en: 'APIs',
        icon: ApisIconComponent,
        url: REACT_APP_APPS_LIST_LINK,
        isExternalLink: true,
        closeSecondMenuOnClick: true,
      },
    ],
  },
];

// export const MENU_ITEMS = [
//   {
//     text_fa: 'نصب و راه اندازی',
//     text_en: 'installation',
//     icon: InstallAndDeploy,
//     url: routes.widgetInstallation,
//     accessLevels: ['admin'],
//     // hasNotifBadge: true,
//     // subscript_fa: '(نسخه جدید)',
//     // subscript_en: '(New Version)',
//     notifBadgeTooltipText_fa:
//       'از نسخه یک ابزارک استفاده میکنید؟ همین حالا به روزرسانی کنید!',
//     notifBadgeTooltipText_en: 'Are you using widget version 1? Update now!',
//     subItem: [],
//   },
//   {
//     text_fa: 'آمار و ارقام',
//     text_en: 'Statistics',
//     icon: StatisticsIcon,
//     url: '',
//     accessLevels: ['admin'],
//     subItem: [
//       {
//         text_fa: 'مکالمات',
//         text_en: 'Conversations',
//         url: routes.conversationsReport,
//       },
//       {
//         text_fa: 'اپراتور ها',
//         text_en: 'Operators',
//         url: routes.operatorsReport,
//       },
//       {
//         text_fa: 'رضایت مشتری',
//         text_en: 'Customer Success',
//         url: routes.costumerSuccess,
//       },
//     ],
//   },
//   {
//     text_fa: 'اتصال واتساپ',
//     text_en: 'Whatsapp',
//     icon: ConnectWhatsappIcon,
//     url: routes.connectWhatsapp,
//     accessLevels: ['admin'],
//     subItem: [], // TODO: add items
//   },
//   {
//     text_fa: 'تنظیمات تیم',
//     text_en: 'Team Settings',
//     icon: Settings,
//     url: '',
//     accessLevels: ['admin'],
//     subItem: [
//       {
//         text_fa: 'دپارتمان',
//         text_en: 'Departments',
//         url: routes.teams,
//       },
//       {
//         text_fa: 'تخصیص لینک به اپراتور',
//         text_en: 'Assign Link To Operator',
//         url: routes.settingsTeam,
//       },
//     ],
//   },
//   {
//     text_fa: 'پیام گروهی',
//     text_en: 'Group Message',
//     icon: BulkMessageIcon,
//     url: routes.groupMessage,
//     accessLevels: ['admin'],
//     subItem: [],
//   },
//   {
//     text_fa: 'وب هوک',
//     text_en: 'Webhook',
//     icon: WebhookIcon,
//     url: '',
//     accessLevels: ['admin'],
//     subItem: [
//       {
//         text_fa: 'ایجاد وب‌هوک جدید',
//         text_en: 'New Webhook',
//         url: routes.addWebhook,
//       },
//     ],
//   },
//   {
//     text_fa: 'پایگاه دانش',
//     text_en: 'Widget FAQ',
//     icon: KnowledgeBaseIcon,
//     url: '',
//     accessLevels: ['admin'],
//     subItem: [
//       {
//         text_fa: 'لیست پرسش ها',
//         text_en: 'FAQ List',
//         url: routes.faqList,
//       },
//       {
//         text_fa: 'ایجاد پرسش جدید',
//         text_en: 'Add New FAQ',
//         url: routes.addFaq,
//       },
//       {
//         text_fa: 'شخصی سازی پایگاه دانش',
//         text_en: 'FAQ Customization',
//         url: routes.knowledgeBasePage,
//       },
//     ],
//   },

//   {
//     text_fa: 'همکاری در فروش',
//     text_en: 'Affiliate',
//     icon: Affiliate,
//     url: routes.affiliatePage,
//     accessLevels: ['admin'],
//     hasNotifBadge: false,
//     notifBadgeTooltipText_fa: 'کسب درآمد از رایچت',
//     notifBadgeTooltipText_en: 'Have income from Raychat',
//     subItem: [],
//   },
// ];
